/* eslint-disable import/max-dependencies */
import React from "react";
import {
  Table,
} from "@fas/ui-core";
import type { Column } from "@fas/ui-core";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useTable } from "@fas/ui-framework";
import { REDIRECT_LIST } from "../../helpers/constants";
import { getRedirectList } from "../../actions/redirectList/actions";
import RedirectListActions from "./RedirectListActions";
import { getHashValue } from "../../services/jusCan";
import type { Redirect } from "../../reducers/redirectList";

function RedirectList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableProps = useTable<Redirect>(REDIRECT_LIST);

  const onCreate = () => navigate(`/redirects/create?hashId=${getHashValue()}`);

  const columns: Array<Column<Redirect>> = [
    {
      field: "pageUrl",
      label: "Page URL",
      searchable: true,
      sortable: true,
    },
    {
      field: "statusCode",
      label: "Status code",
      searchable: false,
      sortable: false,
    },
    {
      field: "redirectUrl",
      label: "Redirect URL",
      searchable: true,
      sortable: true,
    },
    {
      field: "updatedAt",
      label: "Last update",
      searchable: false,
      sortable: false,
    },
    {
      field: "creator",
      label: "Author",
      searchable: false,
      sortable: false,
    },
  ];
  const onLoad = () => dispatch(getRedirectList());

  return (
    <Table
      {...tableProps}
      title="Redirects"
      columns={columns}
      onLoad={onLoad}
      onCreate={onCreate}
      rowSelectAvailable={() => true}
      allSelectAvailable={() => true}
      Actions={<RedirectListActions />}
    />
  );
}

export default RedirectList;
